import * as React from "react";
import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { getContracts } from "../../http/contractApi";
import ContractModal from "./ContractModal";
import { LOGIN_ROUTE } from "../../utils/constants";
import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react-lite";
import { Context } from "../../index";

const ContractChooser = observer(({ contract, setContract }) => {
  const [contracts, setContracts] = React.useState([]);
  const [openChange, setOpenChange] = React.useState(false);
  const [openNew, setOpenNew] = React.useState(false);
  const navigate = useNavigate();
  const { user } = React.useContext(Context);

  const handleChange = (event) => {
    const found = contracts.find((x) => x.name === event.target.value);
    console.log(found);
    setContract(found);
  };

  const handleChangeModalOpen = () => {
    setOpenNew(false);
    setOpenChange(!openChange);
  };
  const handleNewModalOpen = () => {
    setOpenChange(false);
    setOpenNew(!openNew);
  };

  React.useEffect(() => {
    const getData = async () => {
      try {
        let rows = await getContracts();
        console.log("rows start", rows);
        rows = rows.map((row) => {
          const r = row.singers.map((singer) => {
            let s = JSON.parse(singer);
            console.log(s);
            singer = s;
            return singer;
          });
          row.singers = r;
          return row;
        });
        console.log("rows end", rows);
        setContracts(rows);
      } catch (error) {
        if (error.response.status === 401) {
          localStorage.clear();
          user.setIsAuth(false);
          return navigate(LOGIN_ROUTE);
        }
      }
    };
    getData();
  }, []);

  return (
    <Box
      sx={{
        minWidth: 500,
        maxWidth: 500,
      }}
    >
      <Stack direction="row" spacing={5}>
        <FormControl disabled={contracts.length < 1} required fullWidth>
          <InputLabel id="demo-simple-select-label">Договор</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={contract !== null ? contract.name : ""}
            label="Age"
            color="secondary"
            onChange={handleChange}
          >
            {contracts &&
              contracts.map(({ name }) => {
                return (
                  <MenuItem key={name} value={name}>
                    {name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
        <Button
          color="secondary"
          disabled={!contract}
          onClick={handleChangeModalOpen}
        >
          Изменить
        </Button>
        <Button color="secondary" onClick={handleNewModalOpen}>
          Добавить
        </Button>
      </Stack>
      {openChange && (
        <ContractModal
          open={openChange}
          setOpen={setOpenChange}
          contract={contract}
        />
      )}
      {openNew && <ContractModal open={openNew} setOpen={setOpenNew} />}
    </Box>
  );
});

export default ContractChooser;
